@let merchantAmountVm = merchantAmountVm$ | async;
@if (merchantAmountVm; as vm) {
  @if (vm.orderValidateData; as orderValidate) {
    @if (vm.cartHasProduct) {
      <div
        class="mx-auto max-w-md"
        [style.color]="textColor() | contentBuilderColor"
      >
        @if (getServiceCharges(orderValidate).length > 0) {
          <div class="px-5 lg:px-0">
            @for (item of getServiceCharges(orderValidate); track item) {
              <div>
                <app-overview-cart-additional-atom
                  [text]="item.name ?? ''"
                  [price]="item.final_price ?? 0"
                  [textColor]="textColor()"
                  [secondaryTextColor]="secondaryTextColor()"
                ></app-overview-cart-additional-atom>
              </div>
            }
          </div>
        }

        @if ($any(orderValidate)[orderKeys.DeliveryPriceAmount]) {
          <div class="px-5 lg:px-0">
            <app-overview-cart-additional-atom
              [text]="'basket.delivery-costs' | translate"
              [icon]="'icon-bike'"
              [price]="$any(orderValidate)[orderKeys.DeliveryPriceAmount]"
              [textColor]="textColor()"
              [secondaryTextColor]="secondaryTextColor()"
            ></app-overview-cart-additional-atom>
          </div>
        }
      </div>
    }
  }

  <div class="mx-auto max-w-md">
    @if (errorMessages) {
      @for (message of errorMessages; track message) {
        <div
          class="ng-star-inserted my-6 mb-3 hidden rounded bg-error-50 px-4 py-3 font-base text-sm text-error-700 lg:block"
        >
          {{ message }}
        </div>
      }
    }

    @if (missingLocationIdError) {
      <div
        class="ng-star-inserted my-6 mb-3 hidden rounded bg-error-50 px-4 py-3 font-base text-sm text-error-700 lg:block"
      >
        {{ missingLocationIdError }}
      </div>
    }
  </div>

  @if (!vm.isOrderValidating) {
    @if (vm.orderValidateData; as orderValidate) {
      @if (vm.cartHasProduct) {
        <div class="mx-auto mb-3 max-w-md">
          <app-cart-total-amount-atom
            [totalAmount]="orderValidate[orderKeys.FinalPrice] ?? 0"
            [usePointsAmount]="orderValidate[orderKeys.UsePoints]?.amount ?? 0"
            [discount]="$any(orderValidate)[orderKeys.CouponsAmountOff]"
            [coupons]="orderValidate[orderKeys.Coupons]"
            [tips]="orderValidate[orderKeys.Tip]?.amount ?? 0"
            [isBasketExist]="!!(basketId$ | async)"
            [headingColor]="headingColor()"
            [textColor]="textColor()"
            [secondaryTextColor]="secondaryTextColor()"
            (removeCoupon)="removeCoupon($event)"
            (removeUsePoints)="removeUsePoints()"
          ></app-cart-total-amount-atom>
          <div class="hidden lg:block mt-4">
            @if (
              !!$any(orderValidate)[orderKeys.AvailablePaymentMethods].length &&
              !(basketId$ | async)
            ) {
              <app-button-atom
                [size]="'L'"
                [type]="'primary'"
                (click)="goToPayment()"
                [disabled]="
                  isGoToPaymentInProgress ||
                  !!errorMessages.length ||
                  !vm.orderHasProduct ||
                  (missingPhone$ | async) === true ||
                  onSiteLocationIsMissing === true ||
                  !!missingLocationIdError
                "
                [label]="
                  orderValidate[orderKeys.FinalPrice] === 0
                    ? ('basket.payment_zero' | translate)
                    : ('basket.payment' | translate)
                "
                [iconUrl]="isGoToPaymentInProgress ? 'assets/images/spinner.svg' : ''"
              ></app-button-atom>
            }
            <!-- Buttons for shared order -->
            @if (
              !!$any(orderValidate)[orderKeys.AvailablePaymentMethods].length &&
              (basketId$ | async) &&
              (basket$ | async)?.user?.id === (userId$ | async)
            ) {
              <app-button-atom
                [label]="'basket.payment' | translate"
                [type]="'primary'"
                [size]="'L'"
                (click)="confirmOrder()"
                [disabled]="
                  isGoToPaymentInProgress ||
                  !!errorMessages.length ||
                  !vm.orderHasProduct ||
                  (missingPhone$ | async) === true ||
                  onSiteLocationIsMissing === true ||
                  !!missingLocationIdError
                "
                [iconUrl]="isGoToPaymentInProgress ? 'assets/images/spinner.svg' : ''"
              ></app-button-atom>
            }
            @if (
              !!$any(orderValidate)[orderKeys.AvailablePaymentMethods]?.length &&
              (basketId$ | async) &&
              (basket$ | async)?.user?.id !== (userId$ | async)
            ) {
              <app-button-atom
                [label]="'basket.validate-order' | translate"
                [type]="'primary'"
                [size]="'L'"
                (click)="confirmOrder()"
                [disabled]="
                  isGoToPaymentInProgress ||
                  !!errorMessages.length ||
                  !vm.orderHasProduct ||
                  (missingPhone$ | async) === true ||
                  !!missingLocationIdError
                "
                [iconUrl]="isGoToPaymentInProgress ? 'assets/images/spinner.svg' : ''"
              ></app-button-atom>
            }
          </div>

          <!-- Withdrawing share order from guest -->
          @if ((basketId$ | async) && (basket$ | async)?.user?.id !== (userId$ | async)) {
            <div class="mt-4 px-5 lg:px-0">
              <app-button-atom
                [icon]="'icon-cross'"
                [thickSize]="'S'"
                [full]="true"
                [color]="'neutral'"
                [type]="'light'"
                [label]="'group-order-modal.withdrawing-order-button' | translate"
                (click)="exitGroupOrder()"
              ></app-button-atom>
            </div>
          }
          <!-- Cancel share order from master -->
          @if ((basketId$ | async) && (basket$ | async)?.user?.id === (userId$ | async)) {
            <div class="mt-4 px-5 lg:px-0">
              <app-button-atom
                [icon]="'icon-cross'"
                [thickSize]="'S'"
                [full]="true"
                [color]="'neutral'"
                [type]="'light'"
                [label]="'group-order-modal.cancel-order-button' | translate"
                (click)="cancelGroupOrder()"
              ></app-button-atom>
            </div>
          }
        </div>
      }
    }
  } @else {
    <div class="hidden lg:block mt-4">
      <app-button-atom
        type="primary"
        size="L"
        [label]="'basket.payment' | translate"
        [disabled]="true"
      ></app-button-atom>
    </div>
  }
}
